import { gsap } from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitType from 'split-type'

gsap.registerPlugin(ScrollTrigger);

export class CAnimatedText extends HTMLElement {
  innerClassName = 'c-animated-text__inner';

  connectedCallback() {
    if (document.querySelector('.wp-admin')) return;

    this.prepareMarkup();

    // https://github.com/lukePeavey/SplitType
    const text = new SplitType(this.querySelector('.' + this.innerClassName) as HTMLElement);

    text.lines.map(line => {
      const wrapEl = document.createElement('div');
      wrapEl.classList.add('lines-wrap');
      // or wrapEl.style.overflow = 'hidden'
      line.parentNode?.appendChild(wrapEl);
      wrapEl?.appendChild(line);
    })

    gsap.from(text.lines, {
      scrollTrigger: {
        trigger: this,
        toggleActions: "play",
        start: "0% 75%",
        // scrub: 1,
      },
      ease: "power4.out",
      y: "100%",
      delay: this.getAttribute('delay') || 0,
      duration: 1,
      stagger: 0.1,
      onComplete: () => {
        text.revert()
      }
    })
  }

  prepareMarkup() {
    if (this.childNodes.length === 1 && this.firstChild.nodeType === 1) {
      (this.firstChild as HTMLElement).classList.add(this.innerClassName);
      return;
    }

    const div = document.createElement('div');
    div.classList.add(this.innerClassName);

    // Clone each child node of `this` and append it to the new div
    while (this.firstChild) {
        div.appendChild(this.firstChild);  // `firstChild` is moved to `div`
    }

    // Append the new div to `this`
    this.appendChild(div);
  }
}
customElements.define('c-animated-text', CAnimatedText);